define('app/sdc/inline/edit/controls/sdc-inline-edit-controls',[], function () {
	return {
		require: {
			"crud": "^sdcCrud"
		},
		controller: {
			bind: {
				"disabled": "=ngDisabled"
			}
		}
	};
});
